module.exports = __webpack_public_path__ + "static/livesync_poster-08482a41259f2ae80ce79ce069666b55.jpg";